import React, { useEffect, useState } from "react";
import styles from "../../../css/community-popup.module.css";
import closeIcon from "../../../../../public/images/close_grey.svg";
import MaterialTextFieldOutlinedContainer from "../../../../admin/containers/MaterialTextFieldOutlinedContainer";
import ActionButtonContainer from "../../../../shared/containers/ActionButtonContainer";
import { useDispatch, useSelector } from "react-redux";
import { askQuestion, editQuestion } from "../../../../shared/utils/sash-v2-api";
import { COMMUNITY_ACTION_TYPES } from "../communityReducer";

const AskEditQuestionPopUp = (props) => {
    const [question, setQuestion] = useState("");
    const [description, setDescription] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [enabled, setEnabled] = useState(false);
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.userReducer.userId);
    const allThreads = useSelector((state) => state.communityReducer.allThreads);
    const userQuestions = useSelector((state) => state.communityReducer.userQuestions);
    const trending = useSelector((state) => state.communityReducer.trending);
    const userAnswers = useSelector((state) => state.communityReducer.userAnswers);
    const isEditMode = props.selectedThread;

    useEffect(() => {
        if (props.selectedThread) {
            setQuestion(props.selectedThread.title);
            setDescription(props.selectedThread.description);
        }
    }, [props.selectedThread]);


    const handleQuestionChange = (value) => setQuestion(value);
    const handleDescriptionChange = (value) => setDescription(value);

    const handleSave = async () => {
        if (!question.trim() || !description.trim()) {
            setErrorMessage("All Fields are mandatory*");
            return;
        }
        setErrorMessage("");

        if (isEditMode) {
            const updatedThread = {
                title: question.trim(),
                description: description.trim(),
            };

            const editThreadSuccess = (res) => {
                const { result } = res;
                if (result === "SUCCESS") {
                    const updatedThreads = allThreads.map((thread) =>
                        thread._id === props.selectedThread._id
                            ? { ...thread, ...updatedThread }
                            : thread
                    );
                    const updatedUserQuestions = userQuestions.map((thread) =>
                        thread._id === props.selectedThread._id
                            ? { ...thread, ...updatedThread }
                            : thread
                    );
                    const updatedTrendingQuestions = trending.map((thread) =>
                        thread._id === props.selectedThread._id
                            ? { ...thread, ...updatedThread }
                            : thread
                    );
                    const updatedUserAnswers = userAnswers.map((thread) => {
                        if (thread.question?._id === props.selectedThread._id || thread?._id === props.selectedThread._id) {
                            return {
                                ...thread,
                                question: {
                                    ...thread.question,
                                    ...updatedThread
                                },
                            };
                        }
                        return thread;
                    });
                    dispatch({
                        type: COMMUNITY_ACTION_TYPES.SET_ALL_THREADS,
                        payload: updatedThreads,
                    });
                    dispatch({
                        type: COMMUNITY_ACTION_TYPES.SET_USER_QUESTIONS,
                        payload: updatedUserQuestions,
                    });
                    dispatch({
                        type: COMMUNITY_ACTION_TYPES.SET_TRENDING,
                        payload: updatedTrendingQuestions,
                    });
                    dispatch({
                        type: COMMUNITY_ACTION_TYPES.SET_USER_ANSWERS,
                        payload: updatedUserAnswers,
                    });
                    props.onClose();
                } else {
                    setErrorMessage("Failed to update the thread. Please try again.");
                    console.error("Unexpected server response:", res);
                }
            };

            const editThreadFailure = (error) => {
                setErrorMessage("An error occurred. Please try again.");
                console.error("Error editing thread:", error);
            };

            editQuestion(props.selectedThread._id, updatedThread, editThreadSuccess, editThreadFailure);
        }
        else {
            const newThread = {
                answer_count: 0,
                created_at: Date.now().toString(),
                title: question.trim(),
                description: description.trim(),
                user_id: userId,
                // _id: mongoObjectID().toString(),
            };

            const addThreadSuccess = (res) => {
                const { result } = res;
                if (result === "SUCCESS") {
                    dispatch({
                        type: COMMUNITY_ACTION_TYPES.SET_ALL_THREADS,
                        payload: [newThread, ...allThreads],
                    });
                    dispatch({
                        type: COMMUNITY_ACTION_TYPES.SET_USER_QUESTIONS,
                        payload: [newThread, ...userQuestions],
                    });
                    dispatch({
                        type: COMMUNITY_ACTION_TYPES.SET_TRENDING,
                        payload: [newThread, ...trending],
                    });
                    props.onClose();
                    window.location.reload()
                } else {
                    setErrorMessage("Failed to add the thread. Please try again.");
                    console.error("Unexpected server response:", res);
                }
            };

            const addThreadFailure = (error) => {
                setErrorMessage("An error occurred. Please try again.");
                console.error("Error adding thread:", error);
            };
            askQuestion(newThread, addThreadSuccess, addThreadFailure);
        }
    };


    useEffect(() => {
        setEnabled(!description.trim() || !question.trim());
    }, [description, question]);

    return (
        <div style={{height: '340px'}} className={styles.popupContainer}>
            <div className={styles.type}>
                <h4>{isEditMode ? "Edit Question" : "Ask Question"}</h4>
                <img
                    onClick={props.onClose}
                    height={12}
                    className={styles.communityPopUpClose}
                    src={closeIcon}
                    alt="close"
                />
            </div>
            <div className={styles.communityErrorMessage}>
                <MaterialTextFieldOutlinedContainer
                    inputType={"text"}
                    placeHolder={"Question"}
                    autoFocus={true}
                    onChange={handleQuestionChange}
                    defaultValue={question}
                    value={question}
                />

                <MaterialTextFieldOutlinedContainer
                    inputType="textarea"
                    placeHolder={"Description"}
                    textArea={true}
                    customStyleObject={{height: '150px'}}
                    onChange={handleDescriptionChange}
                    defaultValue={description}
                    value={description}
                />

                {errorMessage &&
                    <p style={{color: "red", textAlign: 'center', fontSize: '14px', margin: '0'}}>
                        {errorMessage}
                    </p>}

                <div className={styles.buttonType}>
                    <ActionButtonContainer
                        buttonText={isEditMode ? "EDIT" : "ASK"}
                        height="40px"
                        bgColor={enabled ? "#E0E0E0" : ""}
                        buttonWidth="100px"
                        handleClick={handleSave}
                        fontWeight="bold"
                    />
                </div>
            </div>
        </div>
    );
};

export default AskEditQuestionPopUp;